import { styled } from "styled-components";
import Logo from "../assets/images/logoWhite.png";
import { Link } from "react-router-dom";
function Footer() {
  return (
    <FooterWrapper>
      <IconHeader>
        <H1>
          <Link to="/">
            <img src={Logo} alt="" width="150" height="70" />
          </Link>
        </H1>
      </IconHeader>
      <TargetLink
        href="https://www.sc.com/en/privacy-policy/"
        rel="noreferrer"
        target="_blank"
      >
        <p>PRIVACY NOTICE</p>
      </TargetLink>

      <p>
        &copy; Standard Chartered {new Date().getFullYear()}. All rights
        reserved.
      </p>
    </FooterWrapper>
  );
}

export default Footer;

const FooterWrapper = styled.footer`
  background-image: linear-gradient(90deg, #2c3a88, #0061c8);
  height: 100px;
  display: flex;
  align-items: center;
  font-size: 13px;
  justify-content: space-evenly;
  p {
    color: #fff;
  }
`;

const IconHeader = styled.section``;

const TargetLink = styled.a`
  text-decoration: none;
`;
const H1 = styled.h1`
  border: none;
  margin: 0;
  padding: 16px 0;
`;
